<template>
    <div
        class="c-menu p-emoji_picker"
        data-using-keyboard="false"
        role="presentation"
        data-qa="emoji-picker"
        v-show="visible_flag"
    >
        <div class="p-emoji_picker__content p-emoji_picker__content--reaction-height-without-cta">
            <emoji-picker-search @input="handle_search" />
            <div
                class="p-emoji_picker__list_container"
                role="tabpanel"
                aria-labelledby="emoji-picker-sticky-header"
            >
                <div class="p-emoji_picker__list">
                    <template>
                        <div v-for="(item, group_key) in items">
                          <div
                              class="p-emoji_picker__row row-header"
                              :key="`row-${group_key}`"
                          >
                            <h3 class="p-emoji_picker__heading">{{item.name}}</h3>
                          </div>
                          <template>
                            <div  v-for="(rows, row_key) in split_in_rows(item.emojis)">
                              <div
                                  class="p-emoji_picker__row"
                                  role="presentation"
                                  :key="`g-${group_key}-row-${row_key}`"
                              ><button
                                  class="c-link--button p-emoji_picker__list_item"
                                  data-qa="emoji_list_item"
                                  role="option"
                                  tabindex="-1"
                                  type="button"
                                  v-for="(emoji, key) in rows"
                                  :data-color-index="emoji.colorIndex"
                                  :data-name="emoji.id"
                                  :key="`g-${group_key}-row-${row_key}-button-${key}`"
                                  @click="handle_select(emoji)"
                                  @mouseout="hovered = {}"
                                  @mouseover="hovered = emoji"
                              ><img
                                  :src="emoji[skin_tone] || emoji.default"
                                  class="c-emoji c-emoji__medium"
                                  data-qa="emoji"
                                  data-stringify-type="emoji"
                                  :data-stringify-emoji="emoji.id"
                              ></button>
                              </div>
                            </div>
                          </template>
                        </div>
                    </template>
                </div>
            </div>
            <div
                :class="['p-emoji_picker__footer', 'p-emoji_picker__footer--handy-reactions', {'p-emoji_picker__footer--previewing': !!hovered}]"
                data-qa="emoji_picker__footer"
            >
                <div class="p-emoji_picker__handy_rxns">
                    <h3 class="p-emoji_picker__heading p-emoji_picker__heading--handy_rxns">Handy Reactions</h3>
                    <div
                        class="p-emoji_picker__handy_rxns_list"
                        role="menu"
                    >

                        <button
                            class="c-button-unstyled p-emoji_picker__list_item"
                            type="button"
                            v-for="(emoji, key) in handy_reactions"
                            :data-color-index="emoji.colorIndex"
                            :key="`hr-${key}`"
                            @click="handle_select(emoji)"
                            @mouseout="hovered = {}"
                            @mouseover="hovered = emoji"
                        ><img
                                :src="emoji[skin_tone] || emoji.default"
                                class="c-emoji c-emoji__medium"
                                data-qa="emoji"
                                data-stringify-type="emoji"
                                :data-stringify-emoji="`:${emoji.id}:`"
                            >
                        </button>
                    </div>
                </div>
                <div
                    class="p-emoji_picker__preview"
                    v-if="hovered.id"
                >
                    <span
                        class="p-emoji_picker__preview_img"
                        data-qa="emoji_preview_img"
                    ><img
                            :src="hovered[skin_tone] || hovered.default"
                            aria-label="grin emoji"
                            alt="grin"
                            class="c-emoji c-emoji__large"
                            data-qa="emoji"
                            data-stringify-type="emoji"
                            data-stringify-emoji="grin"
                        >
                    </span>
                    <div class="p-emoji_picker__preview_text"><span data-qa="emoji_preview_name">{{hovered.name}}</span><br><span
                            class="p-emoji_picker__preview_aliases"
                            data-qa="emoji_preview_aliases"
                        >:{{hovered.name}}:</span></div>
                </div>
                <div
                    class="p-emoji_picker_skintone"
                    role="presentation"
                >
                    <div
                        role="radiogroup"
                        aria-labelledby="emoji-picker-skintone-radiogroup-label"
                        class="p-emoji_picker_skintone__radiogroup"
                        v-if="skin_tone_menu_active"
                    >
                        <div
                            id="emoji-picker-skintone-radiogroup-label"
                            class="p-emoji_picker_skintone__radiogroup_label"
                        >Choose your default skin tone</div>
                        <div
                            class="p-emoji_picker_skintone__radio_buttons"
                            data-qa="emoji_skintone_options"
                        >

                            <div
                                class="p-emoji_picker_skintone__radio_button_container"
                                v-for="(st, st_key) in skin_tones_options"
                                v-show="!selected_skin_tone || st.skin_tone !== selected_skin_tone.skin_tone"
                                :key="st_key"
                                @click="skin_tone_menu_active = false; selected_skin_tone = st; skin_tone = st.skin_tone"
                            >
                                <div aria-hidden="true">
                                    <img
                                        :src="st.url"
                                        aria-label="hand emoji with light skin tone"
                                        class="c-emoji c-emoji__medium"
                                        data-qa="emoji"
                                        data-stringify-type="emoji"
                                    >
                                </div>
                            </div>
                            <div
                                class="p-emoji_picker_skintone__radio_button_container p-emoji_picker_skintone__radio_button_container--focus-visible"
                                v-if="selected_skin_tone"
                                @click="skin_tone_menu_active = false"
                            >
                                <div aria-hidden="true">
                                    <img
                                        :src="selected_skin_tone.url"
                                        aria-label="hand emoji with light skin tone"
                                        class="c-emoji c-emoji__medium"
                                        data-qa="emoji"
                                        data-stringify-type="emoji"
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                    <button
                        class="c-button-unstyled p-emoji_picker_skintone__toggle_btn"
                        data-qa="emoji_selected_skintone"
                        aria-label="Choose your default skin tone"
                        type="button"
                        v-else
                        @click="skin_tone_menu_active = true"
                    >
                        <div>
                            <img
                                :src="selected_skin_tone ? selected_skin_tone.url: skin_tones_options[0].url"
                                aria-label="hand emoji"
                                alt=":hand:"
                                class="c-emoji c-emoji__medium"
                                data-qa="emoji"
                                data-stringify-type="emoji"
                                data-stringify-emoji=":hand:"
                            >
                        </div>
                        <span
                            class="p-emoji_picker_skintone__toggle_btn_label"
                            data-qa="emoji_skintone_label"
                        >Skin Tone</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { get_frequently_used_emojis, set_frequently_used_emojis } from '../../slack_api'
import { set_position } from '../../utils'
import EmojiPickerSearch from './EmojiPickerSearch'
import emojis from './emojis.json'
export default {
    beforeDestroy() {
        if (typeof window !== 'undefined') {
            document.removeEventListener('click', this.clicked_outside)
        }
        this.$el.remove()
    },
    components: {
        EmojiPickerSearch,
    },
    computed: {
        handy_reactions() {
            return [{
                "id": "slightly_smiling_face",
                "colorIndex": "2",
                "name": "slightly_smiling_face",
                "qa": "emoji_list_item",
                "default": "https://a.slack-edge.com/production-standard-emoji-assets/13.0/apple-medium/1f642.png"
            },
            {
                "id": "thumbsup",
                "colorIndex": "3",
                "name": "thumbsup",
                "qa": "emoji_list_productivity_item",
                "default": "https://a.slack-edge.com/production-standard-emoji-assets/13.0/apple-medium/1f44d.png",
                "skin-tone-2": "https://a.slack-edge.com/production-standard-emoji-assets/13.0/apple-medium/1f44d-1f3fb.png",
                "skin-tone-3": "https://a.slack-edge.com/production-standard-emoji-assets/13.0/apple-medium/1f44d-1f3fc.png",
                "skin-tone-4": "https://a.slack-edge.com/production-standard-emoji-assets/13.0/apple-medium/1f44d-1f3fd.png",
                "skin-tone-5": "https://a.slack-edge.com/production-standard-emoji-assets/13.0/apple-medium/1f44d-1f3fe.png",
                "skin-tone-6": "https://a.slack-edge.com/production-standard-emoji-assets/13.0/apple-medium/1f44d-1f3ff.png"
            }, {
                "id": "heavy_check_mark",
                "colorIndex": "5",
                "name": "heavy_check_mark",
                "qa": "emoji_list_item",
                "default": "https://a.slack-edge.com/production-standard-emoji-assets/13.0/apple-medium/2714-fe0f.png"
            },
            {
                "id": "heart",
                "colorIndex": "2",
                "name": "heart",
                "qa": "emoji_list_item",
                "default": "https://a.slack-edge.com/production-standard-emoji-assets/13.0/apple-medium/2764-fe0f.png"
            },
            {
                "id": "eyes",
                "colorIndex": "1",
                "name": "eyes",
                "qa": "emoji_list_productivity_item",
                "default": "https://a.slack-edge.com/production-standard-emoji-assets/13.0/apple-medium/1f440.png"
            },
            ]
        },
        items() {
            if (this.search_term) {
                const results = []
                emojis.forEach(i => {
                    i.emojis.forEach(e => {
                        const regexp = new RegExp(`.*${this.search_term}.*`, 'gi')
                        if (regexp.test(e.name)) {
                            results.push(e)
                        }
                    })
                })
                return [{ id: 'search_results', emojis: results, name: 'Search results' }]
            }
            return [this.frequently_used, ...emojis]
        },
    },
    created() {
        if (typeof window !== 'undefined') {
            document.addEventListener('click', this.clicked_outside)
        }
    },
    data() {
        return {
            frequently_used: {
                id: 'Frequently_Used', emojis: get_frequently_used_emojis() || [], name: 'Frequently Used'
            },
            hovered: {},
            search_term: '',
            selected_skin_tone: null,
            skin_tone: 'default',
            skin_tone_menu_active: false,
            skin_tones_options: [
                { skin_tone: 'default', url: "https://a.slack-edge.com/production-standard-emoji-assets/13.0/apple-medium/270b.png" },
                { skin_tone: 'skin-tone-2', url: "https://a.slack-edge.com/production-standard-emoji-assets/13.0/apple-medium/270b-1f3fb.png" },
                { skin_tone: 'skin-tone-3', url: "https://a.slack-edge.com/production-standard-emoji-assets/13.0/apple-medium/270b-1f3fc.png" },
                { skin_tone: 'skin-tone-4', url: "https://a.slack-edge.com/production-standard-emoji-assets/13.0/apple-medium/270b-1f3fd.png" },
                { skin_tone: 'skin-tone-5', url: "https://a.slack-edge.com/production-standard-emoji-assets/13.0/apple-medium/270b-1f3fe.png" },
                { skin_tone: 'skin-tone-6', url: "https://a.slack-edge.com/production-standard-emoji-assets/13.0/apple-medium/270b-1f3ff.png" },
            ],
            visible_flag: false,
        }
    },
    methods: {
        clicked_outside(event) {
            if (!this.visible_flag) return
            const picker = this.$el
            if (picker && !picker.contains(event.target)) {
                this.visible_flag = false
            }
        },
        handle_search: _.debounce(function (e) {
            this.search_term = e.target.value
            this.$forceUpdate()
        }, 250),
        handle_select(emoji) {
            const name = `${emoji.id}${this.skin_tone === 'default' ? '' : `::${this.skin_tone}`}`
            this.$emit('selected', { emoji, skin_tone: this.skin_tone, name })
            let emojis = get_frequently_used_emojis() || []
            emojis = emojis.filter(i => i.id !== emoji.id)
            emojis.unshift(emoji)
            emojis = emojis.slice(0, 27)
            this.frequently_used.emojis = emojis
            set_frequently_used_emojis(emojis)
        },
        hide() {
            this.visible_flag = false
        },
        show(e) {
            this.$nextTick(() => {
                this.visible_flag = true
                this.$nextTick(() => {
                    set_position(e.target, this.$el, .5, .9)
                })
            })
        },
        split_in_rows(emojis) {
            const l = emojis.length,
                row_length = 9
                , total_rows = Math.ceil(l / row_length)
            let rows = []
            if (l === 0) return []
            for (let idx = 0; idx < total_rows; idx++) {
                rows = [...rows, emojis.slice(idx * row_length, (idx + 1) * row_length)]
            }
            return rows
        }
    },
    mounted() {
        document.body.appendChild(this.$el)
    },
}
</script>

<style>
.p-emoji_picker .p-emoji_picker__list_container {
  overflow: auto; }
.p-emoji_picker .p-emoji_picker__list_container .p-emoji_picker__list {
  position: relative; }
.p-emoji_picker .p-emoji_picker__list_container .p-emoji_picker__list .p-emoji_picker__row.row-header {
  position: sticky;
  top: 0; }
.p-emoji_picker .p-emoji_picker__list_container .p-emoji_picker__list .p-emoji_picker__row:last-of-type {
  padding-bottom: 10px; }

</style>